import { createSelector } from "reselect";
//EXTRACT THE PART OF THE STATE
const appSelector = state => state.app;

const isRightSidebarOpen = createSelector(appSelector, data => data.rightBar);

export default isRightSidebarOpen;



// WEBPACK FOOTER //
// ./src/_selectors/appSelectors/isRightBarOpen.js